import Seo from '../components/common/Seo';
import { SITE_NAME, SITE_URL, CONTACT_EMAIL, LEGAL_UPDATED } from '../constants/site';

// TODO: have this reviewed before launch — it is a starting template, not legal advice.
function TermsOfService() {
  return (
    <div className="container page prose">
      <Seo
        title="Terms of Service"
        path="/terms"
        description={`The terms that apply when you use ${SITE_NAME}.`}
      />

      <h1 className="page-title">Terms of Service</h1>
      <p className="page-sub">
        Last updated: <time dateTime={LEGAL_UPDATED}>{LEGAL_UPDATED}</time>
      </p>

      <h2>Acceptance</h2>
      <p>
        By accessing {SITE_NAME} ({SITE_URL}) you agree to these terms. If you do not agree, please
        do not use the site.
      </p>

      <h2>Content and accuracy</h2>
      <p>
        Articles are published for general information only. We take care to be accurate, but we do
        not warrant that content is complete, current or error-free. Nothing here is professional,
        legal, medical or financial advice.
      </p>

      <h2>Intellectual property</h2>
      <p>
        All text, images and layout on this site are owned by {SITE_NAME} or used with permission.
        You may link to and quote short excerpts with attribution; republishing whole articles
        requires written permission.
      </p>

      <h2>External links</h2>
      <p>
        Articles may link to third-party sites, including partner or affiliate links. We do not
        control those sites and are not responsible for their content, products or policies.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Do not attempt to gain unauthorised access to the site or its admin area.</li>
        <li>Do not scrape, overload or disrupt the service.</li>
        <li>Do not use the site for anything unlawful.</li>
      </ul>

      <h2>Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, {SITE_NAME} is not liable for any indirect or
        consequential loss arising from your use of the site or reliance on its content.
      </p>

      <h2>Changes</h2>
      <p>
        We may modify these terms or any part of the site at any time. Continued use after changes
        means you accept the updated terms.
      </p>

      <h2>Contact</h2>
      <p>
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
    </div>
  );
}

export default TermsOfService;
